// @ts-ignore - JS module
import { WSClient } from '../../../../goServerAPI/apiBase/wsClient.js';
import { callSummaryService } from './services';

export let summarizerWSClient: typeof WSClient | null = null;

export const setSummarizerWSClient = (client: typeof WSClient | null) => {
  summarizerWSClient = client;
};

export const createSummarizerActions = (set: any, get: any) => ({
  updateSummarizerSummary: (summary: string) => {
    if (!summarizerWSClient) {
      console.warn('[SUMMARIZER_STORE] Cannot update summary: WebSocket client not available');
      return;
    }

    try {
      const updateMessage = {
        type: 'update_summary',
        summary: summary,
      };

      console.log('[SUMMARIZER_STORE] Sending summary update to backend:', {
        summaryLength: summary.length,
        summaryPreview: summary.substring(0, 100),
      });

      summarizerWSClient.send(updateMessage);
    } catch (error) {
      console.error('[SUMMARIZER_STORE] Failed to send summary update:', error);
    }

    set((state: any) => {
      const accSummary = state.salesCallStatus.accumulatedSummary;
      const timestamp = new Date().toISOString();
      const newMsgId = accSummary.summaryMessageIdCounter + 1;

      return {
        salesCallStatus: {
          ...state.salesCallStatus,
          accumulatedSummary: {
            ...accSummary,
            messages: [
              {
                id: `summary-msg-${newMsgId}`,
                text: summary,
                timestamp,
              },
            ],
            lastProcessedSummaryRef: summary,
            summaryMessageIdCounter: newMsgId,
          },
        },
      };
    });
  },

  updateSummarizerAmmo: (ammoItems: { id: string, text: string, timestamp?: string }[]) => {
    const { salesCallStatus } = get();
    set((state: any) => {
      const newAccumulatedSummary = {
        ...state.salesCallStatus.accumulatedSummary,
        ammoItems: ammoItems,
        lastProcessedAmmoRef: JSON.stringify(ammoItems.map((a: any) => a.text))
      };

      return {
        salesCallStatus: {
          ...state.salesCallStatus,
          accumulatedSummary: newAccumulatedSummary
        }
      };
    });

    if (summarizerWSClient) {
      try {
        const updateMessage = {
          type: 'update_ammo',
          ammo: ammoItems.map(item => item.text)
        };
        console.log('[SUMMARIZER_STORE] Sending ammo update to backend:', updateMessage);
        summarizerWSClient.send(updateMessage);
      } catch (error) {
        console.error('[SUMMARIZER_STORE] Failed to send ammo update via WS:', error);
      }
    } else {
      console.warn('[SUMMARIZER_STORE] Cannot update ammo: WebSocket client not available');
    }

    const callId = salesCallStatus.callId;
    if (callId) {
      try {
        const currentAgentData = salesCallStatus.agentData.summarizer || {};
        const summaryPayload = {
          summary: currentAgentData.summary || '',
          ammo: ammoItems.map(item => item.text).join('***'),
          keyPoints: currentAgentData.keyPoints || [],
          actionItems: currentAgentData.actionItems || [],
          nextStep: currentAgentData.nextStep || '',
          new_feedback: currentAgentData.new_feedback || [],
          type: 'summarizer',
          new_ammo: ammoItems.map(item => item.text)
        };

        const summaryText = JSON.stringify(summaryPayload);
        const timestamp = new Date().toISOString();

        console.log('💾 [SUMMARIZER_STORE] Persisting manual ammo update to DB', { callId, itemsCount: ammoItems.length });

        callSummaryService
          .createSummary(callId, summaryText, timestamp)
          .then((res) => {
            if (res) console.log('✅ [SUMMARIZER_STORE] Ammo update saved to DB');
            else console.error('❌ [SUMMARIZER_STORE] Ammo update save returned null');
          })
          .catch((err) => console.error('❌ [SUMMARIZER_STORE] Ammo update DB save failed', err));

      } catch (error) {
        console.error('❌ [SUMMARIZER_STORE] Error constructing ammo payload for DB:', error);
      }
    } else {
      console.warn('⚠️ [SUMMARIZER_STORE] Skipping ammo DB save: missing callId');
    }
  },
});
